import { TableCellRenderer } from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

export interface SupportTicketsTableProps {
  ActionButton?: TableCellRenderer;
}
/**
 * Support ticket table columns for customers
 */
export const customerSupportTicketsColumns = (params: SupportTicketsTableProps): CustomTableColumn[] => {
  const supportTicketColumnsCustomer: CustomTableColumn[] = [
    globalTableColumns.id(),
    globalTableColumns.SupportTicketStatusColumn(),
    globalTableColumns.SupportTicketIssueType(),
    globalTableColumns.date({
      width: 120,
      header: "Created At",
      accessor: "createdAt"
    }),
    globalTableColumns.date({
      width: 120,
      header: "Delivery Date",
      id: "orderDeliveryDate",
      accessor: "order.orderDeliveryDate",
      sortable: false
    }),
    globalTableColumns.standardText({
      width: 100,
      Header: "PO Number",
      accessor: "order.customerReference"
    }),

    globalTableColumns.actions({ cell: params.ActionButton })
  ];

  return supportTicketColumnsCustomer;
};
